import { render, staticRenderFns } from "./SsoError.vue?vue&type=template&id=6665ed62&scoped=true"
import script from "./SsoError.vue?vue&type=script&lang=js"
export * from "./SsoError.vue?vue&type=script&lang=js"
import style0 from "./SsoError.vue?vue&type=style&index=0&id=6665ed62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665ed62",
  null
  
)

export default component.exports